import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ShortInfoModalComponent } from '../short-info-modal/short-info-modal.component';
import { RecommendationModalAction, RecommendationModalComponent } from '../recommendation-modal/recommendation-modal.component';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import {
	defaultsToArticleOption,
	getAvailability,
	getBasePrice,
	getPrice,
	numberD,
	numberToCurrency,
	sleep,
} from '../../../smoothr-web-app-core/utils/utils';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { filterMatchingOptions, OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { DisplayMode } from '../../../smoothr-web-app-core/enums/DisplayMode';
import { DisplayIdentifier } from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import FulfilledDependency from '../../../smoothr-web-app-core/models/FulfilledDependency';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { environment } from 'src/environments/environment';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { shoGif } from '../item-view/item-view.component';
import { ShowRemoveIngrediantsDialogComponent } from '../show-remove-ingrediants-dialog/show-remove-ingrediants-dialog.component';
import { AllergensInfoModalComponent } from '../allergens-info-modal/allergens-info-modal.component';
import { FormControl } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';

@Component({
	selector: 'app-modal-info',
	templateUrl: './modal-info.component.html',
	styleUrls: ['modal-info.component.scss'],
})
export class ModalInfoComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	articleGroup: ArticleGroup;
	// false if coming from checkout
	recommend = true;
	noQuantity = false;

	OrderUtils = OrderUtils;
	validationUtils = ValidationUtils;

	findFeatureArray: string[] = [];
	showGif = shoGif.default;
	dm = DisplayMode;
	di = DisplayIdentifier;
	errorOptionItemId: string = null;

	addOnGroups: OptionGroup[] = [];
	pages: OptionGroup[][] = [];
	currentPageIndex = 0;
	indicesOfRecommendations: number[] = [];

	numberToCurrency = numberToCurrency;
	getPrice = getPrice;
	getBasePrice = getBasePrice;
	filterMatchingOptions = filterMatchingOptions;
	checkIfButtonFinishedAvailable = false;
	isFavourite: boolean = false;
	showMostWanted: boolean = false;
	isCloseButtonValid: boolean = false;
	checkVeganFeatureValue = '';
	public isCreateYourOwn = false;
	public enterNotes = new FormControl('');
	public filtersValues: string[] = [];
	public isSmallScreen = !AppComponent.largeScreen;
	public listOfHidden = [];
	public allListOfHidden = [];
	constructor(
		public modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackBarCtrl: MatSnackBar,
		private translate: TranslateService,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef
	) {
		super(repository);
	}

	isPageOverlay(pageIndex: number): boolean {
		return pageIndex !== 0 && this.pages[pageIndex][0].displayMode !== DisplayMode.DETAIL_OVERLAY;
	}

	get type(): PreorderType {
		return this.order.preorder.type;
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.beginArticleEdit(this.articleGroup.article);
		let articleIsCreateOwn = !!this.articleGroup.article.tags.find(it => it.identifier == 'create_own');

		const listGroups = this.articleGroup.article.groups.filter(
			it => !(it.tags && it.tags.find(tag => tag.identifier == 'modifier_remove' || tag.identifier == 'modifier_select'))
		);
		if (this.pages.length === 0) {
			this.pages.push([]);
		}
		for (const group of listGroups) {
			const index = Math.floor(group.sortOrder / 10);
			const foundArticlesWithModifiers = (group?.articles ?? []).filter(
				it =>
					!!it.tags.find(
						tag =>
							tag.identifier === 'filter_superfood' ||
							tag.identifier === 'filter_premium' ||
							tag.identifier === 'filter_basic'
					)
			);
			if (foundArticlesWithModifiers.length > 0) {
				const foundArticlesSuperFood = (group?.articles ?? []).filter(
					it => !!it.tags.find(tag => tag.identifier === 'filter_superfood')
				);
				const foundArticlesPremium = (group?.articles ?? []).filter(
					it => !!it.tags.find(tag => tag.identifier === 'filter_premium')
				);
				const foundArticlesBasic = (group?.articles ?? []).filter(it => !!it.tags.find(tag => tag.identifier === 'filter_basic'));
				if (foundArticlesSuperFood.length > 0) {
					const copyGroup = JSON.parse(JSON.stringify(group)) as OptionGroup;
					copyGroup.description = {
						...copyGroup.description,
						de: 'Superfood Extras',

						en: 'Superfood Extras',
					};
					copyGroup.articles = foundArticlesSuperFood;

					this.pages[0].push(copyGroup);
				}
				if (foundArticlesPremium.length > 0) {
					const copyGroup = JSON.parse(JSON.stringify(group)) as OptionGroup;
					copyGroup.description = {
						...copyGroup.description,
						de: 'Premium Extras',
						en: 'Premium Extras',
					};
					copyGroup.articles = foundArticlesPremium;
					this.pages[0].push(copyGroup);
				}
				if (foundArticlesBasic.length > 0) {
					const copyGroup = JSON.parse(JSON.stringify(group)) as OptionGroup;
					copyGroup.description = {
						...copyGroup.description,
						de: 'Basic Extras',
						en: 'Basic Extras',
					};
					copyGroup.articles = foundArticlesBasic;
					this.pages[0].push(copyGroup);
				}
			} else {
				const isAccordion = group.tags.find(t => t.identifier === 'hidden_accordion'); //todo: create enums
				if (isAccordion && articleIsCreateOwn) this.addOnGroups.push(group);
				else if (!isAccordion) this.pages[0].push(group);
			}
		}
		if (this.pages.length > 1) {
			this.pages = this.pages.filter(page => page !== null);
		}

		this.indicesOfRecommendations = [];
		this.pages.forEach((page, pageIndex) => {
			if (page.length > 0 && this.articleGroup.article.recommendations.find(recommendation => recommendation.group === page[0]._id)) {
				this.indicesOfRecommendations.push(pageIndex);
			}
		});

		if (this.articleGroup.article.tags.find(it => it.identifier === 'most_wanted')) {
			this.showMostWanted = true;
		}
		console.log(this.articleGroup);
		try {
			this.isCloseButtonValid = ValidationUtils.areGroupsValid(this.articleGroup, this.pages[0]);
		} catch (e) {
			this.isCloseButtonValid = false;
		}
		this.checkVeganFeature(this.articleGroup.article);
		if (AppComponent.largeScreen) {
			console.log('IS LARGE', AppComponent.largeScreen, this.articleGroup.article);
			this.isCreateYourOwn = !!this.articleGroup.article.tags.find(it => it.identifier == 'create_own');
		}
		this.findFeature(this.articleGroup.article);
		this.listOfHidden = (this.articleGroup.article.groups ?? [])
			.filter(group => group.tags.length > 0 && group.tags.find(tag => tag.identifier === 'hidden_accordion'))
			.map(it => it._id);
		this.listOfHidden.push('ADD_ON_MAIN');
		this.allListOfHidden = this.listOfHidden;
	}

	selectedFilters(event: string[]) {
		console.log(event);
		this.filtersValues = event;
	}

	checkIfArticleIsVisible(optionGroup: OptionGroup) {
		return (
			optionGroup?.articles?.filter(
				it => it?.visible && it?.isActive && getAvailability(it, OrderType.PREORDER, this.order?.preorder?.type)
			).length > 0
		);
	}

	async finish(isAddToCheckout: boolean = false) {
		if (this.enterNotes.value) {
			this.articleGroup.note = this.enterNotes.value;
		}
		this.analytics.finishArticleEdit(this.articleGroup.article, this.currentPageIndex);
		await this.modalCtrl.dismiss({
			articleGroup: this.articleGroup,
			isAddToCheckout,
		});
	}

	async close() {
		this.analytics.cancelArticleEdit(this.articleGroup.article, this.currentPageIndex);
		await this.modalCtrl.dismiss();
	}

	increase() {
		this.articleGroup.quantity += 1;
	}

	decrease() {
		if (this.articleGroup.quantity > 1) {
			this.articleGroup.quantity -= 1;
		}
	}

	optionGroupDisabled(optionGroup: OptionGroup): boolean {
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
			const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
			const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
			const matchingBogoArticleIndices = this.order.orderedArticles
				.map((ag, agIndex) => {
					return ag.article._id === bogoArticle.article._id &&
						!ag.isPromo &&
						OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
							OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
						? agIndex
						: -1;
				})
				.filter(agIndex => agIndex !== -1);
			// article that should be removed is a possible parent of promoCode article
			if (
				matchingBogoArticleIndices.length === 1 &&
				bogoArticle.article._id === this.articleGroup.article._id &&
				OrderUtils.bogoPrice(this.articleGroup, this.order.type, this.order.preorder.type) ===
					OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
			) {
				return !this.recommend;
			}
		}
		return this.articleGroup.isPromo && optionGroup.displayIdentifiers.indexOf(DisplayIdentifier.main) >= 0;
	}

	async add(
		pageIndex: number,
		optionGroupIndex: number,
		option: ArticleOption,
		group: OptionGroup,
		fulfilledDependency: FulfilledDependency,
		dependencyNumber: number
	) {
		this.errorOptionItemId = null;
		OrderUtils.addOptionNew(this.articleGroup.groups, option, group, fulfilledDependency, dependencyNumber);
		this.isCloseButtonValid = ValidationUtils.areGroupsValid(this.articleGroup, this.pages[0]);
		this.articleGroup.groups = this.articleGroup.groups.filter(group => {
			const foundOption = this.articleGroup.article.groups.find(it => it._id === group.group);
			if (!foundOption) {
				return false;
			}
			const dependencies = ValidationUtils.isGroupDependencyFulfilled(
				this.articleGroup.article,
				this.articleGroup.groups,
				foundOption
			);
			if ((dependencies.times > 0 && group.dependencyNumber === 0) || group.dependencyNumber > dependencies.times) {
				return false;
			}
			return true;
		});

		// Scroll to next group if only two groups exist ( Sabrina and client request )
		if (this.articleGroup.article.groups.length === 2) {
			console.log(this.articleGroup.article.groups[1]._id);
			setTimeout(() => {
				const targetElement = document.getElementById(this.articleGroup.article.groups[1]._id);
				console.log(targetElement);
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}, 500);
		}

		this.articleGroup.article.groups.forEach(grp => {
			if (ValidationUtils.areGroupsValid(this.articleGroup, [grp])) {
				console.log('Group valid', grp);
				return;
			}
			if (grp.limit != grp.requiredAmount || grp.limit != grp.articles.length || grp.hasMultiple) {
				return;
			}

			const dependency = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, this.articleGroup.groups, grp);
			// console.log(dependency);
			for (let depNumber = 1; depNumber <= dependency.times; depNumber++) {
				// console.log('For Each', depNumber);

				grp.articles.forEach(opt => {
					const option = new ArticleOption();
					option.article = opt;
					option.group = grp._id;
					option.dependency = dependency?.dependency?._id;
					option.dependencyNumber = depNumber;
					option.dependsOn = dependency?.dependsOn;
					option.quantity = 1;
					OrderUtils.addOptionNew(this.articleGroup.groups, option, grp, dependency, depNumber);
				});
			}
		});

		this.isCloseButtonValid = ValidationUtils.areGroupsValid(this.articleGroup, this.pages[0]);
	}

	async addToOrder(finished: boolean = false, navigateBasket: boolean = false) {
		this.errorOptionItemId = null;

		// Simplified Logic: Check combined validation of all groups
		const allGroups = this.articleGroup.article.groups;

		if (
			this.recommend &&
			this.articleGroup.article.recommendations &&
			this.articleGroup.article.recommendations.length > 0 &&
			ValidationUtils.areGroupsValid(this.articleGroup, allGroups)
		) {
			const recommendations = defaultsToArticleOption(
				this.articleGroup.article,
				this.articleGroup.groups,
				this.articleGroup.article.recommendations,
				OrderType.PREORDER,
				this.order.preorder.type
			);
			const groups: OptionGroup[] = [];
			this.articleGroup.article.recommendations.forEach(option => {
				const insertedGrp = groups.find(grp => grp._id === option.group);
				if (!insertedGrp) {
					const group = this.articleGroup.article.groups.find(grp => option.group === grp._id);
					// only fulfilled recommendations are relevant
					if (ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, recommendations, group).times >= 0) {
						groups.push(this.articleGroup.article.groups.find(grp => option.group === grp._id));
					}
				}
			});
			// Check if some recommendations are inactive before we allow the user to select recommendations
			const allRequiredAvailable = groups
				.map(grp => recommendations.filter(opt => opt.group === grp._id).length)
				.map((value, index) => groups[index].requiredAmount <= value)
				.reduce((previousValue, currentValue) => previousValue && currentValue, true);
			const recommendationAction = allRequiredAvailable
				? await RecommendationModalComponent.show(this.modalCtrl)
				: RecommendationModalAction.CUSTOMIZATION;
			switch (recommendationAction) {
				case RecommendationModalAction.CUSTOMIZATION:
					this.articleGroup.isRecommendedRecipe = false;
					this.recommend = false;
					return;
				case RecommendationModalAction.DISMISS:
					return;
				case RecommendationModalAction.RECOMMENDATION:
					this.articleGroup.isRecommendedRecipe = true;
					const optionsToKeep = [
						...this.articleGroup.groups.filter(
							option => this.pages[0].findIndex(optionGroup => optionGroup._id === option.group) >= 0
						),
						...recommendations,
					];
					this.articleGroup.groups = [];
					optionsToKeep.forEach(opt => {
						const grp = this.articleGroup.article.groups.find(group => group._id === opt.group);
						const dep = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, optionsToKeep, grp);
						OrderUtils.addOption(this.articleGroup.groups, opt, grp, dep);
					});
					await this.finish(navigateBasket);
					return;
				default:
					return;
			}
		} else {
			// General Validation Check
			if (!ValidationUtils.areGroupsValid(this.articleGroup, this.articleGroup.article.groups)) {
				const result = ValidationUtils.findInvalidGroup(this.articleGroup, this.articleGroup.article.groups);
				if (result) {
					this.errorOptionItemId = result._id;
					const element = document.getElementById(result._id);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				} else {
					this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'), null, {
						duration: 2000,
					});
				}

				return;
			}

			// Success
			if (finished) {
				await this.finish(navigateBasket);
			}
		}
	}

	async openInfo(article: Article) {
		await ShortInfoModalComponent.show(this.modalCtrl, article.info);
	}

	currentPage(): OptionGroup {
		return this.pages[this.currentPageIndex][0];
	}

	checkIfHiddenOption(id: string) {
		return this.listOfHidden.includes(id);
	}
	checkMainHidden(id: string) {
		return this.allListOfHidden.includes(id);
	}
	changeOpen(id: string) {
		const check = this.listOfHidden.includes(id);
		if (check) {
			this.listOfHidden = this.listOfHidden.filter(it => it != id);
		} else {
			this.listOfHidden.push(id);
		}
	}

	isAllergens(article: Article) {
		if (article?.compound?.allergens) return Object.values(article?.compound?.allergens)?.find(it => it === true);
		else return null;
	}
	checkVeganFeature(article: Article) {
		const result = Object.entries(article.compound?.features)
			.filter(it => it[0] == 'vegetarian' || it[0] == 'vegan')
			.filter(it => !!it[1])
			.map(it => it[0]);
		if (result && result?.length > 1) {
			this.checkVeganFeatureValue = result[1];
		} else {
			this.checkVeganFeatureValue = result[0];
		}
	}

	/* Restore missing methods */
	showNutrition(article: Article) {
		AllergensInfoModalComponent.show(this.modalCtrl, article);
	}

	generateDependencies(fulfilledDependency: FulfilledDependency): number[] {
		if (fulfilledDependency.times === 0) return [0];
		if (fulfilledDependency.times === -1) return [];
		const dependencyNumbers: number[] = [];
		for (let dependencyNumber = 1; dependencyNumber <= fulfilledDependency.times; dependencyNumber++) {
			dependencyNumbers.push(dependencyNumber);
		}
		return dependencyNumbers;
	}

	findFeature(article: Article) {
		if (this.findFeatureArray.length > 0) {
			return;
		}
		this.findFeatureArray = [];
		if (article) {
			if (article?.compound?.allergens && article.compound.allergens['cerealsContainingGluten'] == true) {
				this.findFeatureArray.push('gluten');
			}
			if (article?.compound?.allergens && article.compound.allergens['peanutsAndProductsThereof'] == true) {
				this.findFeatureArray.push('peanut');
			}
			if (article?.compound?.allergens && article.compound.allergens['milkAndProductsThereof'] == true) {
				this.findFeatureArray.push('lactose');
			}
		}
	}

	pageVisible(pageIndex: number): boolean {
		// Some pages needs to be invisible (if dependencies are not fulfilled or recommendations taken)

		return (
			(((!this.articleGroup.isRecommendedRecipe || this.indicesOfRecommendations.indexOf(pageIndex) < 0) &&
				ValidationUtils.someGroupsFulfilled(this.articleGroup, this.pages[pageIndex])) ||
				!ValidationUtils.areGroupsValid(this.articleGroup, this.pages[pageIndex])) &&
			(pageIndex > 0
				? !!this.pages[pageIndex].find(it => it.visible) &&
					!!this.pages[pageIndex][0]?.articles?.find(
						it => it?.visible && getAvailability(it, OrderType.PREORDER, this.order.preorder.type)
					)
				: true)
		);
	}

	isAddit(article: Article) {
		if (article?.compound?.additives) return Object.values(article?.compound?.additives)?.find(it => it === true);
		else return null;
	}
	isHaveAnyValueMoreZero(article: Article) {
		return Object.values(article.nutritions)
			.map(it => (numberD(it) ? numberD(it) : 0))
			.find(it => it > 0);
	}
}
